import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Modal,
  Theme,
  Typography,
} from '@mui/material';
import { createStyles, makeStyles, useTheme } from '@mui/styles';
import { MESSAGES } from '../assets/messages';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      borderRadius: '20px !important',
      width: '50%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    cardHeader: {
      padding: 'rem 0 !important',
    },
    iconButton: {
      padding: '0px !important',
    },
    icon: {
      color: theme.palette.primary.main,
    },
    avatar: {
      padding: '0.5rem',
      marginBottom: '1rem',
      backgroundColor: `${theme.palette.success.main} !important`,
      width: '60px !important',
      height: '60px !important',
    },
    successIcon: {
      color: 'white',
      fontSize: '60px !important',
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '1rem !important',
    },
    modalText: {
      textAlign: 'center',
      marginBottom: '2rem !important',
    },
    successButton: {
      color: 'white !important',
    },
  }),
);

const SuccessModal = ({ open, onClose }: any) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Modal open={open} onClose={() => {}}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Avatar className={classes.avatar}>
            <CheckRoundedIcon className={classes.successIcon} />
          </Avatar>

          <Typography component="h5" variant="h5" className={classes.modalText}>
            {MESSAGES['card.success']}
          </Typography>

          <Button variant="contained" color="primary" onClick={onClose}>
            <Typography
              component="h5"
              variant="h5"
              className={classes.successButton}
            >
              {MESSAGES['card.close']}
            </Typography>
          </Button>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default SuccessModal;
